import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import * as ObjectConst from '../../constants/Property';
import {updateField, setOtherValid} from '../../actions/CreatingObjectPage';
import classnames from "classnames";
import {all as checkTimeTypes, FLEXIBLE} from "../../constants/CheckTime";

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    }
};

class Other extends Component {
    constructor(props) {
        super(props);

        this.state = {
            DEPOSIT: '',
            LICENSE: '',
            MIN_DAYS: '',
            CLEANING: '',
            EXCESS_FARE: '',
            MAX_STAY: '',
            CHECK_IN_START_TIME: FLEXIBLE.enum,
            CHECK_IN_END_TIME: FLEXIBLE.enum,
            CHECK_OUT_TIME: FLEXIBLE.enum
        }
    }

    componentWillReceiveProps(nextProps) {
        const {createdObject} = nextProps;
        if (createdObject.id !== undefined) {
            const price = createdObject.price;
            const props = createdObject.props;

            this.setState({
                DEPOSIT: price.deposit === 0 || price.deposit === '0' ? '' : price.deposit,
                MIN_DAYS: price.minDays === 0 || price.minDays === '0' ? '' : price.minDays,
                LICENSE: props.license === null || props.license === '0' ? '' : props.license,
                CLEANING: price.cleaning === 0 || price.cleaning === '0' ? '' : price.cleaning,
                EXCESS_FARE: price.excessFare === 0 || price.excessFare === '0' ? '' : price.excessFare,
                MAX_STAY: price.maxStay === 0 || price.maxStay === '0' ? '' : price.maxStay,
                TYPE_RULE_RESERVATION: createdObject.props.cancellationRule,
                CHECK_IN_START_TIME: createdObject.props.checkInStartTime,
                CHECK_IN_END_TIME: createdObject.props.checkInEndTime,
                CHECK_OUT_TIME: createdObject.props.checkOutTime
            });
        }
    }

    updateField(event) {
        const updateFieldCommand = {
            name: event.target.name
        };

        switch (event.target.name) {
            case ObjectConst.FIELDS.DEPOSIT:
            case ObjectConst.FIELDS.LICENSE:
            case ObjectConst.FIELDS.CLEANING:
            case ObjectConst.FIELDS.MIN_DAYS:
            case ObjectConst.FIELDS.MAX_STAY:
            case ObjectConst.FIELDS.EXCESS_FARE:
                updateFieldCommand.value = event.target.value.length === 0 ? '0' : event.target.value;
                break;
            default:
                updateFieldCommand.value = event.target.value;
                break;
        }

        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
        this.validation();
    }

    handleChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    validation() {
        let isOtherValid = true;

        if (this.state.MIN_DAYS.length === 0 || this.state.MIN_DAYS < 1 || this.state.LICENSE === '') {
            isOtherValid = false;
        }

        if(this.state.MAX_STAY.length === 0 || this.state.MAX_STAY < 1){
            isOtherValid = false;
        }

        if (this.props.isOtherValid !== isOtherValid) {
            this.props.setOtherValid(isOtherValid);
        }
    }

    getCheckTimeOptions(flexEnable) {
        return checkTimeTypes.filter(e => {
            if (flexEnable) {
                return true;
            }
            return e.enum !== FLEXIBLE.enum;
        }).map(e => {
                return (
                    <option value={e.enum} key={e.enum}>
                        {e.value}
                    </option>
                );
            });
    }

    render() {
        const i18n = this.props.i18n;
        let type = this.props.createdObject.props.type;

        let {createdObject} = this.props;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.other']}
                    </h3>
                </div>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>{i18n['creatingObjectPage.amountOfTheInsuranceDeposit']} {createdObject.price.currency}</span>
                    </span>
                    {i18n['creatingObjectPage.insuranceDeposit']}, {createdObject.price.currency}:
                    <input
                        placeholder="0"
                        value={this.state.DEPOSIT}
                        onBlur={::this.updateField}
                        onChange={::this.handleChange}
                        name={ObjectConst.FIELDS.DEPOSIT}
                    />
                </label>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.amountOfSurchargeForEachGuest']}
                        </span>
                    </span>
                    {i18n['creatingObjectPage.surchargeForGuest']}, {createdObject.price.currency}:
                    <input
                        placeholder="0"
                        onBlur={::this.updateField}
                        value={this.state.EXCESS_FARE}
                        onChange={::this.handleChange}
                        name={ObjectConst.FIELDS.EXCESS_FARE}
                    />
                </label>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>{i18n['creatingObjectPage.cleaningCosts']}</span>
                    </span>
                    {i18n['creatingObjectPage.cleaning']}, {createdObject.price.currency}:
                    <input
                        placeholder="0"
                        onBlur={::this.updateField}
                        value={this.state.CLEANING}
                        onChange={::this.handleChange}
                        name={ObjectConst.FIELDS.CLEANING}
                    />
                </label>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>{i18n['creatingObjectPage.minimumPeriodForWhichGuestsCanBook']}</span>
                    </span>
                    {i18n['creatingObjectPage.minimumLengthOfStay']}:
                    <input
                        placeholder="0"
                        onBlur={::this.updateField}
                        value={this.state.MIN_DAYS}
                        onChange={::this.handleChange}
                        name={ObjectConst.FIELDS.MIN_DAYS}
                        className={classnames({
                            'invalid': this.state.MIN_DAYS.length === 0 || this.state.MIN_DAYS < 1
                        })}
                    />
                </label>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>{i18n['creatingObjectPage.other.maxStay.hint']}</span>
                    </span>
                    {i18n['creatingObjectPage.other.maxStay']}
                    <input
                        placeholder="0"
                        onBlur={::this.updateField}
                        value={this.state.MAX_STAY}
                        onChange={::this.handleChange}
                        name={ObjectConst.FIELDS.MAX_STAY}
                        className={classnames({
                            'invalid': this.state.MAX_STAY.length === 0 || this.state.MAX_STAY < 1
                        })}
                    />
                </label>

                {type === ObjectConst.TYPE.RENT && <div className="grid grid-width-1-3">
                    <div>
                        <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                       {i18n['creatingObjectPage.other.checkInStart.hint']}
                                    </span>
                                </span>
                            {i18n['creatingObjectPage.other.checkInStart']}
                            <select
                                value={this.state.CHECK_IN_START_TIME}
                                onBlur={::this.updateField}
                                onChange={::this.handleChange}
                                name={ObjectConst.FIELDS.CHECK_IN_START_TIME}
                            >
                                {this.getCheckTimeOptions(true)}
                            </select>
                        </label>
                    </div>
                    <div>
                        <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                           {i18n['creatingObjectPage.other.checkInEnd.hint']}
                                    </span>
                                </span>
                            {i18n['creatingObjectPage.other.checkInEnd']}
                            <select
                                value={this.state.CHECK_IN_END_TIME}
                                onBlur={::this.updateField}
                                onChange={::this.handleChange}
                                name={ObjectConst.FIELDS.CHECK_IN_END_TIME}
                            >
                                {this.getCheckTimeOptions(true)}
                            </select>
                        </label>
                    </div>
                    <div>
                        <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                       {i18n['creatingObjectPage.other.checkOut.hint']}
                                    </span>
                                </span>
                            {i18n['creatingObjectPage.other.checkOut']}
                            <select
                                value={this.state.CHECK_OUT_TIME}
                                onBlur={::this.updateField}
                                onChange={::this.handleChange}
                                name={ObjectConst.FIELDS.CHECK_OUT_TIME}
                            >
                                {this.getCheckTimeOptions(false)}
                            </select>
                        </label>
                    </div>
                </div>}

                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.indicateCancellationPolicy']}
                        </span>
                    </span>
                    {i18n['creatingObjectPage.cancellationPolicy']}:
                    <select
                        onBlur={::this.updateField}
                        onChange={::this.handleChange}
                        value={this.state.TYPE_RULE_RESERVATION}
                        name={ObjectConst.FIELDS.TYPE_RULE_RESERVATION}
                    >
                        {this.props.typeRuleReservations.map(item => {
                                if (item.title !== null) {
                                    return <option key={item.value} value={item.value}>{item.title}</option>
                                } else {
                                    return null;
                                }
                            }
                        )}
                    </select>
                </label>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.other.licence.hint']}
                        </span>
                    </span>
                    {i18n['creatingObjectPage.other.licence']}
                    <input
                        type="text"
                        placeholder="-"
                        value={this.state.LICENSE}
                        onChange={::this.handleChange}
                        onBlur={::this.updateField}
                        name={ObjectConst.FIELDS.LICENSE}
                        className={classnames({
                            'invalid': this.state.LICENSE.length === 0
                        })}
                    />
                </label>
            </div>
        )
    }
}

Other.propTypes = propTypes;
Other.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    createdObject: state.creatingObjectPage.createdObject,
    typeRuleReservations: state.configuration.object.typeRuleReservations,
    isOtherValid: state.creatingObjectPage.validation.isOtherValid
});

const mapDispatchToProps = {
    updateField,
    setOtherValid
};

export default connect(mapStateToProps, mapDispatchToProps)(Other);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Other.js